module.exports = "/dist/4faec832c91a7732ce67680e1492238e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900italic.woff2
// module id = 167
// module chunks = 0